/* eslint-disable new-cap */
import { get } from 'lodash';
import { reject } from 'redux-optimist-promise';
import {
  FETCH_USER_PAST_TRIPS,
  FETCH_USER_PAST_TRIPS_RESOLVED,
  RESET_USER_PAST_TRIPS,
} from 'Store/constants';
import createReducer from 'Store/utils/createReducer';

export const initialState = {
  data: {
    bookings: [],
  },
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
  hasNextPage: false,
  currentPage: 1,
  nextPage: 2,
};

export default createReducer(initialState, {
  [FETCH_USER_PAST_TRIPS](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [FETCH_USER_PAST_TRIPS_RESOLVED](state, action) {
    const hasNextPage = get(action, 'payload.userBookings.pageInfo.hasNextPage');
    const currentPage = get(action, 'payload.userBookings.pageInfo.currentPage');
    const fetchedPastTripsList = get(action, 'payload.userBookings.data', []);
    const pastTrips = get(state, 'data.bookings').concat(fetchedPastTripsList);
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      data: {
        bookings: pastTrips,
      },
      hasNextPage,
      currentPage,
      nextPage: currentPage + 1,
    };
  },
  [reject(FETCH_USER_PAST_TRIPS)](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: false,
      errorResponse: {
        errors: action.payload.errors,
      },
    };
  },
  [RESET_USER_PAST_TRIPS]() {
    return initialState;
  },
});
